// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"490f5ffa","230":"f8b55221","376":"81ffc5b6","771":"eb3aa395","992":"ecd02001"}[chunkId] + ".chunk.css";
};